exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-sidebar-link-wrapper{position:relative}.task-sidebar-link-badge{position:absolute;top:1px;display:flex;align-items:center;justify-content:center;width:13px;height:13px;z-index:1;font-size:12px;cursor:pointer}.task-sidebar-link-badge-right{right:-6.5px}.task-sidebar-link-badge-left{left:-6.5px}", ""]);

// exports
